import { $document } from '../global';
import { blockManager } from './blocks';
import { cartManager, ProductChangeRequest, ProductRemoveRequest } from './cart';
import { overlayManager } from './overlay';
class ProductsManager {
    constructor() {
        this.initOptions();
    }
    initOptions() {
        $document.on('change', '.Product_OptionInput', (e) => {
            const $this = $(e.currentTarget);
            const value = $this.val();
            const productId = $this.closest('.js-Product').data('product-id');
            if (!value || !productId)
                return;
            const $options = $(`.js-Product[data-product-id="${productId}"] .Product_OptionInput[value="${value}"]`);
            $options.prop('checked', true);
            this.optionSelected($this);
        });
    }
    openQuickOrder(btn) {
        const $btn = $(btn);
        const $container = $btn.closest('.js-GridItem');
        if (!$container.length)
            return;
        const $overlay = $container.find('.js-ProductQuickOverlay');
        if (!$overlay.length)
            return;
        // A product without options should be added immediately
        if ($btn.hasClass('Btn-Default') && !$overlay.find('.Product_Options').length) {
            this.add(btn);
            return;
        }
        overlayManager.open($overlay);
    }
    buildProductChangeRequestFromContainer($container) {
        const productId = $container.data('product-id');
        if (!productId && isNaN(productId))
            return;
        const categoryId = $container.data('category-id');
        if (!categoryId && isNaN(categoryId))
            return;
        const options = [];
        const $options = $container.find('.Product_Options');
        $options.each((index, elem) => {
            const $elem = $(elem);
            const $option = $elem.find('.Product_OptionInput:checked');
            const value = $option.val();
            if (!value)
                return;
            options.push(value);
        });
        if ($options.length !== options.length)
            return;
        return new ProductChangeRequest(productId, categoryId, options);
    }
    buildProductRemoveRequestFromBtn($container) {
        const productId = $container.data('product-id');
        if (!productId && isNaN(productId))
            return;
        return new ProductRemoveRequest(productId);
    }
    getProductContainer($elem) {
        return $elem.closest('.js-Product');
    }
    optionSelected($option) {
        const $container = this.getProductContainer($option);
        if (!$container.length)
            return;
        const request = this.buildProductChangeRequestFromContainer($container);
        if (!request)
            return;
        cartManager.productPrice(request, $container, (succeeded) => {
            if (!succeeded) {
                // Todo: show retry button?
            }
        });
    }
    add(btn) {
        const $btn = $(btn);
        const $container = this.getProductContainer($btn);
        if (!$container.length)
            return;
        const request = this.buildProductChangeRequestFromContainer($container);
        if (!request)
            return;
        cartManager.addProduct(request, $container, (succeeded) => {
            if (succeeded) {
                blockManager.close($btn[0]);
            }
        });
    }
    change(btn) {
        const $btn = $(btn);
        const $container = this.getProductContainer($btn);
        if (!$container.length)
            return;
        const request = this.buildProductChangeRequestFromContainer($container);
        if (!request)
            return;
        cartManager.changeProduct(request, $container, (succeeded) => {
            if (succeeded) {
                blockManager.close($btn[0]);
            }
        });
    }
    remove(btn) {
        const $btn = $(btn);
        const $container = this.getProductContainer($btn);
        if (!$container.length)
            return;
        const request = this.buildProductRemoveRequestFromBtn($container);
        if (!request)
            return;
        cartManager.removeProduct(request, $container, (succeeded) => {
            if (succeeded) {
                blockManager.close($btn[0]);
            }
        });
    }
}
const productsManager = new ProductsManager();
window.productsManager = productsManager;
